import { resolveCssLengthToPx, useElementHeight } from '@cast/utils';

import { LAST_ROW_ADDITIONAL_PADDING } from '../../../constants';
import { NormalizedTableProps } from '../../../types';

export const useMaxHeight = (
  tableProps: NormalizedTableProps,
  rootRef: HTMLElement | undefined,
  config: {
    peripheralsHeight: number;
    disableHeightCalc: boolean;
    rowsAmount: number;
  }
): number | null => {
  const calcParentHeight = tableProps.fillParentHeight && !!rootRef;
  const parentHeight = useElementHeight(
    rootRef?.parentElement,
    calcParentHeight
  );
  if (config.disableHeightCalc) {
    return null;
  }
  if (tableProps.maxHeight) {
    if (rootRef) {
      const parsedHeight = parseInt(getComputedStyle(rootRef).maxHeight);
      if (!isNaN(parsedHeight)) {
        return parsedHeight;
      }
      return resolveCssLengthToPx(tableProps.maxHeight, rootRef);
    }
    return 1;
  }

  if (calcParentHeight) {
    return parentHeight !== null ? Math.round(parentHeight) : null;
  }

  if (tableProps.maxRows) {
    const allRowsAreVisible = tableProps.maxRows >= config.rowsAmount;
    const rowBorders = tableProps.maxRows - 1;

    return (
      tableProps.maxRows * tableProps.rowHeight +
      config.peripheralsHeight +
      (allRowsAreVisible ? LAST_ROW_ADDITIONAL_PADDING : 0) +
      rowBorders
    );
  }
  return 1;
};
